import axios from 'axios';
import { toQueryString } from '@/helpers/';

export const state = {
  bankAccounts: [],
  totalElements: 0,
  loading: false,
};

export const mutations = {
  CLEAR_DATA(context) {
    context.bankAccounts = [];
    context.currPage = 0;
    context.nextToken = null;
    context.totalElements = 0;
  },

  SET_BANK_ACCOUNTS(context, bankAccounts) {
    bankAccounts.forEach((bankAccount) => {
      const index = context.bankAccounts.findIndex(item => item.id === bankAccount.id);

      if (index === -1) {
        // Element not found in the array, add it
        context.bankAccounts.push(bankAccount);
      } else {
        // Element found in the array, update it
        context.bankAccounts[index] = bankAccount;
      }
    });
  },
  SET_BANK_ACCOUNT_ITEM(context, item) {
    // check if its a bank account and update with new data
    const { bankAccounts } = context;
    let index = -1;

    index = bankAccounts.findIndex(el => item.id === el.id);
    if (index > -1) {
      bankAccounts[index] = { ...bankAccounts[index], ...item };
    }

    context.bankAccounts = bankAccounts;
  },
  SET_LOADING(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async clearEIEBankAccountsData({ commit }) {
    commit('CLEAR_DATA');
  },
  async fetchEIEBankAccounts({ commit, rootState }, params) {
    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      const query = toQueryString(params);

      commit('SET_LOADING', true);

      const URL = `${window.BASE_API.EIE_ADMIN_BASE}/bank-accounts?${query}`;
      const result = await axios.get(URL, options)
        .then(response => response.data);
      const bankAccounts = result || [];

      commit('SET_BANK_ACCOUNTS', bankAccounts);
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);
  },
  async hideEIEBankAccount({ commit, rootState }, params) {
    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      const payload = {};

      commit('SET_LOADING', true);

      const { data } = await axios.put(`${window.BASE_API.EIE_ADMIN_BASE}/bank-accounts/${params.userId}/${params.iban}/hide`, payload, options);
      delete data.message;

      commit('SET_BANK_ACCOUNT_ITEM', { id: params.userId, iban: params.iban, ...data });
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);
  },
};

const eieBankAccountsStore = {
  state,
  mutations,
  actions,
};

export default eieBankAccountsStore;



// WEBPACK FOOTER //
// ./src/store/eieBankAccounts/eieBankAccountsStore.js